<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Folder
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Folder"
      text="Create Folder"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col
              v-if="parent.department"
              cols="12"
            >
              <v-checkbox
                v-model="isPrivate"
                :disabled="parent.is_private ? true : false"
              >
                <template v-slot:label>
                  <div>
                    Is Private?
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      parent: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        isPrivate: false,
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()     

        if (!this.parent.department) {
          this.isPrivate = 0
        }

        if (this.parent.is_private) {
          this.isPrivate = this.parent.is_private
        }
      },
    },

    methods: { 
      prepareFormData () {
        return {
          name: this.name,
          parent: this.parent.id,
          is_private: this.isPrivate,
          department_id: this.parent.department,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.myQualityManagement().create(this.prepareFormData())
              .then((res) => {
                this.$emit('created', res.data)                
                this.$snack({ message: 'Added new folder' })

                this.progressing = false
                this.dialog = false
              })
              .catch(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
